export const MAIN_NAV = [
  { label: '公司概述', href: 'about.html', id: 'about' },
  { label: '雇主品牌', href: 'talentCommitment.html', id: 'talentCommitment' },
  { label: '校园项目', href: 'recruitCollege.html', id: 'recruitCollege' },
  { label: '社会招聘', href: 'recruitSociety.html', id: 'recruitSociety' },
  { label: '如何申请', href: 'apply.html', id: 'apply' },
];

export function getMainNav(activeId) {
  return MAIN_NAV.map((item) => ({
    ...item,
    active: item.id === activeId,
  }));
}
